import { formatMac } from "../../Device/Helper";

export const mapWhiteListDeviceToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const whiteListDeviceColumns = [
  { key: "no", label: "No. (#)", align: "center" },
  { key: "status", label: "Status", align: "center" },
  {
    key: "ethMac",
    label: "MAC Address",
    align: "center",
    render: (item) => formatMac(item.ethMac),
  },
  { key: "firstActiveDate", label: "First active date", align: "center" },
  { key: "fptId", label: "FPT Id", align: "center" },
  { key: "phone", label: "Phone", align: "center" },
  { key: "importDate", label: "Import Date", align: "center" },
  { key: "lastModify", label: "Last Modify", align: "center" },
];
